import React from "react";
import { LinkedArtistsPanel } from "./LinkedArtistsPanel";
import { ButtonSecondary } from "components/Atoms/Button";
import MultiArtistList from "components/Picker/ArtistPicker/MultiArtistList";
import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";

interface Props {
  webformId: number;
  formUrl: string;
}

export const LinkedArtistsWebformPanel = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);


  const onAddArtists = async (newArtists: server.dto.ArtistSmall[]) => {
    await window.CoreApi.WebformConfiguration.LinkArtists({
      webformId: props.webformId,
      artistIds: newArtists.map(a => a.artistId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const unlinkArtist = async (artist: server.dto.ArtistForList) => {
    await window.CoreApi.WebformConfiguration.UnlinkArtists({
      webformId: props.webformId,
      artistIds: [artist.artistId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedArtistsPanel
      renderLastColumn={(artist) =>
        <ButtonSecondary label={RESX.Webform.PreviewForm} onClick={() => window.open(`${props.formUrl}&artist=${artist.artistId}`)} />}
      queryKey={queryKeyIncrement.toString()}
      perPage={10}
      instruction={{
        artistSecurityScope: "allForClient",
        webform: {
          webformId: props.webformId,
          webformWhereInOrNotIn: "in"
        }
      }}
      onDelete={unlinkArtist}
      onAdd={() => setIsNewModalOpen(true)}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.artist.plural}
      modalSize="mini"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddArtists}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiArtistList
        securityScope="allForClient"
        webform={{
          webformId: props.webformId,
          webformWhereInOrNotIn: "notIn"
        }}
        hideActiveFilter
        onChange={setEditedValue}
        value={editedValue}
      />
      }
    />}
  </>
};